import React from 'react';

const Fleet = () => {
    return <div></div>;
};

export default Fleet;
